import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './quote-tile.component.scss';
var QuoteTile = /** @class */ (function (_super) {
    tslib_1.__extends(QuoteTile, _super);
    function QuoteTile(element) {
        return _super.call(this, element) || this;
    }
    QuoteTile.prototype.init = function () {
    };
    QuoteTile.prototype.bindEvents = function () {
    };
    return QuoteTile;
}(Base));
export { QuoteTile };



//////////////////
// WEBPACK FOOTER
// ./components/quote-tile/quote-tile.component.ts
// module id = 592
// module chunks = 0